export default __webpack_public_path__ + "static/media/RealEstateblack.1d319f71.svg";